import { render, staticRenderFns } from "./MenuItemParent.vue?vue&type=template&id=e46a70c2&"
import script from "./MenuItemParent.vue?vue&type=script&lang=js&"
export * from "./MenuItemParent.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemParent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports